module.exports = __webpack_public_path__ + "static/assets/de787f0af75a8a6da1e40057c7b01199.png";